/*
  Lavish navigation, 2026-10-22 (Ido: "make sure navigation is awesome both desktop and mobile").

  A link in the phone menu to a part of the page already open (find yours and questions on the homepage, build your own
  on the sets page) changed the address and left the menu open over the page with its scrolling locked, so nothing
  seemed to happen. Now the menu closes first, and once it has let go of the page, the page glides to that part.
  Links to other pages, and links opened in a new tab, are left to the browser.

  The menu's scroll lock is released by the theme on the menu's toggle event (assets/dialog.js, a capture listener on
  the document), which comes after its closing animation. Listening on the menu itself runs after that release, so the
  scroll starts on an unlocked page. The timer covers a page whose animations never run (a background tab).
*/
const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

document.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest('header-drawer a[href*="#"]') : null;
  if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const url = new URL(link.href, window.location.href);
  if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || url.hash.length < 2) return;

  const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
  if (!target) return;
  event.preventDefault();

  const go = () => {
    if (window.location.hash !== url.hash) window.history.pushState(null, '', url.hash);
    // The theme sets smooth scrolling on the page, so reduced motion asks for an instant jump by name.
    target.scrollIntoView({ behavior: reduceMotion() ? 'instant' : 'smooth', block: 'start' });
  };

  const drawer = link.closest('header-drawer');
  const menu = drawer ? drawer.querySelector('details[scroll-lock]') : null;
  if (!drawer || !menu || !menu.open || typeof drawer.close !== 'function') {
    go();
    return;
  }

  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    menu.removeEventListener('toggle', onToggle);
    go();
  };
  const onToggle = () => {
    if (!menu.open) finish();
  };
  menu.addEventListener('toggle', onToggle);
  window.setTimeout(finish, 1000);
  drawer.close();
});

/*
  The 10% tab on phones waits for the first scroll, 2026-10-24. At first paint on a 375 x 812 phone Klaviyo's tab sat
  exactly on the homepage hero's "read the formula" link, so a tap there opened the popup. This marks a page that has
  moved 80 px (or opened already scrolled: an anchor, a return visit); the stylesheet keeps the tab aside on phones
  until then ("On phones the tab also waits for the first scroll" in assets/lavish.css).
*/
const markScrolled = () => {
  if (window.scrollY < 80) return;
  document.documentElement.classList.add('lavish-scrolled');
  window.removeEventListener('scroll', markScrolled);
};
window.addEventListener('scroll', markScrolled, { passive: true });
markScrolled();
